import React from 'react';
import ButtonIcon, { shouldRenderButtonIcon } from './button-icon.esm.js';
import isReact from '../../utils/is-react.esm.js';
import Flex from '../_primitives/flex/flex.esm.js';

var ButtonIconMemo = /*#__PURE__*/React.memo(ButtonIcon);
function IconLayout(props) {
  var icon = props.icon,
    iconSize = props.iconSize,
    isLoading = props.isLoading;
  return /*#__PURE__*/React.createElement(React.Fragment, null, shouldRenderButtonIcon(icon) ? /*#__PURE__*/React.createElement(ButtonIconMemo, {
    icon: icon,
    iconSize: iconSize,
    isLoading: isLoading
  }) : isReact.element(icon) ? /*#__PURE__*/React.createElement(Flex, {
    opacity: isLoading ? 0 : 1
  }, icon) : null);
}

export default IconLayout;
//# sourceMappingURL=icon.esm.js.map
